import React, { Component } from 'react';
import Flag from 'react-country-flag';
import FlagSpecial from '../../Components/flag-special';
import { getCountryCode } from '../../utils/country-code';
import { translate } from '../../utils/lang-adapters';
import '../../css/match-h2h.css';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

class MatchH2H extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: this.getIsOpenState(),
        };
    }

    getIsOpenState() {
        // Retrieve the object from storage
        let isOpen = true;
        try {
            isOpen = JSON.parse(localStorage.getItem('settings')).matchPage.isOpenH2h
        } catch (error) { }
        return isOpen;
    }

    setIsOpenState(newState) {
        // Retrieve the object from storage
        let storedState = JSON.parse(localStorage.getItem('settings'));
        storedState = {
            ...storedState,
            matchPage: {
                ...storedState.matchPage,
                isOpenH2h: newState,
            }
        }
        // Put the object into storage
        localStorage.setItem('settings', JSON.stringify(storedState));
    }

    toggleMenu() {
        const newState = !this.state.open;
        this.setIsOpenState(newState);
        this.setState({
            open: newState
        })
    }

    Head2HeadStats(h2hArray) {
        if (h2hArray.length > 0) {
            return (
                h2hArray.map((h2h, index) => {
                    return (
                        <div key={index} className="h2h-body-td">
                            <div className="h2h-date">{h2h.date_utc}</div>
                            <div className="competition-flag-h2h ">
                                {(getCountryCode(h2h.area_name) !== ""
                                    ? <Flag countryCode={getCountryCode(h2h.area_name)} svg loading="lazy" alt={'Bandeira de ' + h2h.area_name} className="flagsvg" />
                                    : <FlagSpecial code={h2h.area_name} />
                                )}
                            </div>
                            <div className="competition-name-h2h">
                                {
                                    translate(h2h.competition_name)
                                }
                            </div>
                            <div className="h2h-team">{
                                translate(h2h.team_A_name)
                            }
                            </div>
                            <Link className="h2hid" to={"/match/" + h2h.match_id} >
                                <p className="h2h-result">{h2h.fs_A} - {h2h.fs_B}</p>
                            </Link>
                            <div className="h2h-team">{
                                translate(h2h.team_B_name)
                            }
                            </div>
                        </div>
                    )
                })
            )
        }
    }

    render() {
        return (
            <div className="match-h2h">
                <div className="title-h2h" onClick={() => this.toggleMenu()}>
                    <div className="icons">
                        <span className="ball">
                            <img src="/img/confrontos.svg" alt="" width="20" />
                        </span>
                        <h2>Confrontos Diretos</h2>
                    </div>
                    <img className={classNames(this.state.open && "rotate-icon")} src="/img/arrow.svg" alt="arrow" width="20" />
                </div>
                <div className={classNames("table-h2h", !this.state.open && 'd-none')}>
                    <div className="header-h2h">
                        <div className="h2h-head-td">
                            <div className="h2h-date">DATA</div>
                            <div className="competition-flag-h2h "></div>
                            <div className="competition-name-h2h"></div>
                            <div className="header-h2h-team">CASA</div>
                            <div className="h2h-result"></div>
                            <div className="header-h2h-team">FORA</div>
                        </div>
                    </div>
                    <div className="body-h2h">
                        {this.Head2HeadStats(this.props.data.head2head)}
                    </div>
                </div>
            </div>
        );
    }
}

export default MatchH2H;